import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from 'types';
import { logoutUser } from 'containers/Authentication/actions';

import { UserInfoStyles } from './style';
import { upperCase, get } from 'lodash';

const UserInfo = () => {
  const { givenName, familyName } = useSelector(
    (state: RootState) => state.session.user,
  );
  const dispatch = useDispatch();

  const userInitials = upperCase(
    get(givenName, '0', '') + get(familyName, '0', ''),
  );

  return (
    <UserInfoStyles
      title={<div className="user-container">{userInitials}</div>}
    >
      <NavDropdown.Item disabled>{givenName}</NavDropdown.Item>
      <NavDropdown.Item onClick={() => dispatch(logoutUser())}>
        Sign Out
      </NavDropdown.Item>
    </UserInfoStyles>
  );
};

export default UserInfo;
